import { forwardRef, Children, cloneElement } from 'react';
import { getRadioGroupStyles } from './RadioGroupStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const RadioGroup = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    disabled = false,
    isInvalid = false,
    name,
    value,
    onChange,
    onBlur,
    children,
    ...rest
  } = props;
  const renderRadios = () => {
    const childrenArray = Children.toArray(children);
    return childrenArray.map(radio => radio && /*#__PURE__*/cloneElement(radio, {
      checked: value === radio.props.value,
      disabled,
      name,
      onChange: e => {
        var _radio$props$onChange, _radio$props;
        (_radio$props$onChange = (_radio$props = radio.props).onChange) === null || _radio$props$onChange === void 0 ? void 0 : _radio$props$onChange.call(_radio$props, e);
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
      },
      onBlur: e => {
        var _radio$props$onBlur, _radio$props2;
        (_radio$props$onBlur = (_radio$props2 = radio.props).onBlur) === null || _radio$props$onBlur === void 0 ? void 0 : _radio$props$onBlur.call(_radio$props2, e);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
      },
      isInvalid
    }));
  };
  return jsx("div", {
    css: getRadioGroupStyles,
    ref: ref,
    ...rest,
    children: renderRadios()
  });
});
RadioGroup.displayName = 'RadioGroup';

export { RadioGroup };
//# sourceMappingURL=RadioGroup.js.map
